import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import actions from "../actions";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get() {
    try {
        const { idToken, identityId } = yield select((state) => state.auth);
        const previousItem = yield select((state) => state.userOrganisations.item);
        const url = `${config.api.paths.userOrganisations}?identity_id=${identityId}&source=1`;

        const { data } = yield call(http.authorized.get, url);
        const userOrganisations = data.map((item) => item.organisation);
        yield put(actionCreators.getSuccess(userOrganisations));

        if (userOrganisations.length === 1) {
            yield put(actionCreators.itemSet(userOrganisations[0]));
        } else if (previousItem && previousItem.id) {
            // Re-select previously selected org if still available (e.g. after page refresh)
            const matchingOrg = userOrganisations.find((org) => org.id === previousItem.id);
            if (matchingOrg) {
                yield put(actionCreators.itemSet(matchingOrg));
            }
        }
    } catch (error) {
        console.error(error);
        logToSentry("On user organisations get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

function* itemSet(action) {
    const { userOrganisation } = action.payload;
    try {
        const { auth } = yield select((state) => state);
        const { idToken, identityId } = auth;
        const accountUrl = `${config.api.paths.me}?identity_id=${identityId}&source=1&organisation=${userOrganisation.id}`;
        const account = yield call(http.anonymous.get, accountUrl, {
            Authorization: `Bearer ${idToken}`
        });
        yield all([
            put(
                actions.auth.create.getSuccess({
                    ...auth,
                    adminGroups: account.data[0].groups
                })
            )
        ]);
    } catch (error) {
        console.error(error);
        logToSentry("On user organisation item set:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.USER_ORGANISATIONS_GET_REQUEST, get),
        takeLatest(actionTypes.USER_ORGANISATION_ITEM_SET, itemSet)
    ]);
}
